var exports = {
  "p$": "DMChannelView.module__emptyState___V3hWdU",
  "AI": "DMChannelView.module__emptyStateIcon___V3hWdU",
  "vo": "DMChannelView.module__emptyStateTitle___V3hWdU",
  "Li": "DMChannelView.module__emptyStateDescription___V3hWdU",
  "fX": "DMChannelView.module__callParticipantsRow___V3hWdU",
  "gN": "DMChannelView.module__compactCallParticipantsRow___V3hWdU",
  "Gr": "DMChannelView.module__callParticipant___V3hWdU",
  "Gj": "DMChannelView.module__callParticipantAvatar___V3hWdU",
  "I9": "DMChannelView.module__callParticipantRinging___V3hWdU",
  "rV": "DMChannelView.module__call-participant-ring-pulse___V3hWdU",
  "Jn": "DMChannelView.module__callBanner___V3hWdU",
  "nY": "DMChannelView.module__callBannerBody___V3hWdU",
  "c7": "DMChannelView.module__callBannerResizable___V3hWdU",
  "oo": "DMChannelView.module__callControlBarSection___V3hWdU",
  "Pf": "DMChannelView.module__callControlBarInner___V3hWdU",
  "tX": "DMChannelView.module__callControls___V3hWdU",
  "pm": "DMChannelView.module__callBannerMobile___V3hWdU",
  "h8": "DMChannelView.module__callBannerMobileLabel___V3hWdU",
  "ZI": "DMChannelView.module__callControlsMobile___V3hWdU",
  "IX": "DMChannelView.module__compactCallResizeHandle___V3hWdU",
  "rF": "DMChannelView.module__compactCallResizePill___V3hWdU",
};

module.exports = exports;
